export default __webpack_public_path__ + "static/media/HPSimplified_W_Lt.b9e03b54.woff";